import { ArrowRight, SearchOutlined } from '@mui/icons-material'
import {
  Button,
  Card,
  CardContent,
  Divider,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@mui/material'
import { ExplanationAccordion, LabelField } from 'components'
import { useLayout } from 'context'
import * as controllers from 'controllers'
import { VehicleCheckInDetailsDto } from 'dtos'
import { vehicleCheckInStep1ValidationSchema } from 'dtos/vehicleCheckInDetailsDto'
import { VehicleNeedsClusterRemovedDetailsDto } from 'dtos/vehicleNeedsClusterRemovedDetailsDto'
import { Formik } from 'formik'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface NeedsClusterRemovedPulledClusterPhotoCardProps {
  initialValues: VehicleNeedsClusterRemovedDetailsDto
  onNext: (values: VehicleNeedsClusterRemovedDetailsDto) => void
  onBack: () => void
}

export default function NeedsClusterRemovedPulledClusterPhotoCard({
  initialValues,
  onNext,
  onBack
}: NeedsClusterRemovedPulledClusterPhotoCardProps) {
  const layout = useLayout()
  const { vehicleGuid } = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [parameters, setParameters] = useState({
    page: 0,
    pageSize: 10,
    search: '',
    VIN: undefined,
    openOnly: true
  })

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card variant='outlined'>
          <CardContent>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12}>
                <TextField
                  data-search
                  label='Last 6 of VIN/Importer Stock#'
                  name='search'
                  type='search'
                  size='small'
                  value={parameters.search}
                  onChange={e => setParameters({ ...parameters, search: e.target.value })}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <SearchOutlined fontSize='small' />
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button variant='contained' sx={{ width: '10%' }}>
                  SEARCH
                </Button>
              </Grid>

              <Grid item xs={12}>
                <LabelField label='VIN:' value={initialValues.vin} />
              </Grid>

              <Grid item xs={12}>
                <LabelField label='Year:' value={initialValues.year} />
              </Grid>

              <Grid item xs={12}>
                <LabelField label='Make:' value={initialValues.make} />
              </Grid>

              <Grid item xs={12}>
                <LabelField label='Model:' value={initialValues.model} />
              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant='contained'
                  //  onClick={handleNext}
                  sx={{ width: '20%' }}
                >
                  START CLUSTER REMOVAL
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <ExplanationAccordion variant='outlined'>
          || Pressing “View Details” in the header will open an overlay with additional vehicle details. This overlay can be
          closed by pressing the “X” button in the upper right corner. || Users will enter (scan) the “Last 6 of VIN” or
          “Importer Stock#” into the input field on this screen and then press “Search”. If the scanned/entered value matches
          either the “Last 6 of VIN” or “Importer Stock #” of the selected vehicle, the VIN, Year, Make, and Model fields will
          be populated, and the “Start Cluster Removal” button will be enabled. || Pressing “Start Cluster Removal” will save
          the name of the user who pressed this button along with the date and time into the database and will advance the user
          to the next step in the process. || The expected usage of this screen is that, because a user selected a vehicle on
          the “Needs Cluster Removed” to-do list, users on this screen are scanning one of the barcodes on the “Convert Cluster”
          label, which enters the “Last 6 of VIN” or “Importer Stock#” into the input field on this screen, thus confirming that
          the user is in the correct vehicle. This process helps enforce that users are in the vehicle at the time they are
          indicating that the cluster removal process is beginning. ||
        </ExplanationAccordion>
      </Grid>
    </Grid>
  )
}
